import { CONSOLE_AMPERE_PLATFORM_TEXT_MAP } from '@intelligence/pages/TopCharts/PCGames/_config/constant';

// 格式化 device bar data 数据
export const formatDeviceBarData = (data: any) => {
  const map: Record<string, any> = {};

  data?.forEach((item: any) => {
    const currentMarketData = map[item.market];

    const currentDevice = CONSOLE_AMPERE_PLATFORM_TEXT_MAP[item.device || item.platform] || (item.device || item.platform);

    if (currentMarketData) {
      currentMarketData.metric_device[currentDevice] = [
        {
          metric: item.metric,
          value: item.value,
          device: currentDevice,
        },
      ];
      currentMarketData.value = (currentMarketData.value || 0) + (item.value || 0);
    } else {
      map[item.market] = {
        market: item.market,
        value: item.value,
        metric_device: {
          [currentDevice]: [
            {
              metric: item.metric,
              value: item.value,
              device: currentDevice,
            },
          ],
        },
      };
    }
  });

  const formattedData = Object.values(map);
  formattedData.sort((a, b) => b.value - a.value);

  return formattedData;
};

// 格式化折线图数据
export const formatLineChartData = (data: any) => {
  const map: Record<string, any> = {};

  data?.forEach((item: any) => {
    const currentMarketData = map[item.market];

    if (currentMarketData) {
      currentMarketData.history.push({
        date: item.date,
        value: item.value,
      });
      currentMarketData.value = (currentMarketData.value || 0) + (item.value || 0);
    } else {
      map[item.market] = {
        market: item.market,
        name: item.market,
        value: item.value,
        history: [
          {
            date: item.date,
            value: item.value,
          },
        ],
      };
    }
  });

  const formattedData = Object.values(map);

  return formattedData;
};

// 获取所有国家地区
export const getAllMarkets = (regions: any) => {
  const markets: string[] = [];
  const marketsLocalMap: { [key: string]: { en: string; cn: string } } = {};

  regions?.forEach((region: any) => {
    region?.country_set?.forEach((country: any) => {
      markets.push(country?.country_code);
      marketsLocalMap[country?.country_code] = {
        en: country?.country_name_en,
        cn: country?.country_name_ch,
      };
    });
  });

  return { markets, marketsLocalMap };
};

const dateGranularityMap: { [key: string]: any } = { date: 'daily', month: 'monthly' };

export const granularityDateMap: { [key: string]: any } = { daily: 'date', monthly: 'month' };

// 将筛选器参数格式化为接口所需格式
export const formatFetchParams = (params: { [key: string]: any }) => {
  const currentParams = { ...params };

  const formattedParams: { [key: string]: any } = {
    ...currentParams,

    devices: currentParams.device,
    granularity: dateGranularityMap[currentParams.date_type],
    ids: [currentParams.unified_id],
    source_metrics: { ampere: currentParams.metric },
    b_group_by_market: true,
    // 接口固定默认参数
    platforms: [],
    b_group_by_date: false,
    b_growth_ratio: false,
    b_sum_avg_show: false,
    b_group_by_platform: false,
    b_group_by_device: false,
    b_group_by_segment: false,
    start_release_time: 0,
    end_release_time: 0,
  };

  // 删除修改前的筛选器参数
  ['unified_id', 'device', 'date_type', 'metric'].forEach((key) => {
    delete formattedParams[key];
  });

  return formattedParams;
};
